<template>
  <v-app-bar app clipped-left clipped-right elevation="2" >
    <v-app-bar-nav-icon @click="$emit('drawerClicked')" v-if="$vuetify.breakpoint.mdAndDown"></v-app-bar-nav-icon>
    <v-btn
      icon
      :to="{name: 'feed'}"
      exact
    >
      <img :src="$vuetify.theme.dark ? require('@/assets/images/logo.svg') : require('@/assets/images/logoDark.svg')" width="20"  alt="logo"/>
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn
      :to="{name: 'createPost'}"
      :icon="$vuetify.breakpoint.smAndDown"
      text
      class="ml-1 text--secondary"
    >
      <v-icon>mdi-plus</v-icon> <span v-if="$vuetify.breakpoint.mdAndUp">Create Post</span>
    </v-btn>
    <v-btn
      :to="{name: 'messages'}"
      :icon="$vuetify.breakpoint.smAndDown"
      text
      class="ml-1 text--secondary">
      <v-icon>mdi-chat-processing-outline</v-icon> <span v-if="$vuetify.breakpoint.mdAndUp">Messages</span>
    </v-btn>
<!--    <v-btn-->
<!--      link-->
<!--      :icon="$vuetify.breakpoint.smAndDown"-->
<!--      text-->
<!--      class="ml-1 text&#45;&#45;secondary"-->
<!--    >-->
<!--      <v-icon>mdi-bell-outline</v-icon> <span v-if="$vuetify.breakpoint.mdAndUp">Notifications</span>-->
<!--    </v-btn>-->
<!--    <v-avatar size="40" v-if="currentUser && currentUser.meta">-->
<!--      <v-img :src="currentUser.meta.et_avatar_url"></v-img>-->
<!--    </v-avatar>-->
<!--    <v-avatar size="40" v-else color="primary">-->
<!--    </v-avatar>-->
    <v-btn text :to="{name: 'login'}" v-if="!currentUser">
      Login
    </v-btn>
    <v-menu left bottom offset-y min-width="200">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" class="ml-1 text--secondary">
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item :to="{name: 'myProfile'}">
          <v-list-item-title>
            <v-icon class="mr-1">mdi-account</v-icon> My Profile
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="changeTheme()" >
          <v-list-item-title v-show="!dark">
            <v-icon class="mr-1">mdi-weather-night</v-icon> Dark Mode
          </v-list-item-title>
          <v-list-item-title v-show="dark">
            <v-icon class="mr-1">mdi-white-balance-sunny</v-icon> Light Mode
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="$emit('logout')">
          <v-list-item-title>
            <v-icon class="mr-1">mdi-exit-to-app</v-icon> Logout
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  data () {
    return {
      dark: localStorage.getItem('GB_DARK') === 'true'
    }
  },
  props: {
    drawer: {
      default: null
    },
    currentUser: {
      default: () => {},
      type: Object
    }
  },
  methods: {
    changeTheme () {
      this.$vuetify.theme.dark = !this.dark
      localStorage.setItem('GB_DARK', !this.dark)
      this.dark = !this.dark
    }
  }
}
</script>

<style scoped>

</style>
